/* export const nftmarketaddress = "0x42f3163fF849ceF176174235A74ee0b7556AB8AB"
export const nftaddress = "0x1F37e8F916E982bedb58975ae669d958d0bE1493" */

export const nftmarketaddress = "0x0600D3478e4706398Fc366bDcAd29d3A38979612";
export const nftaddress = "0xda9b2A1633937070657e97bD963F50072A5aE6F7";
